var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D8D8D8",
    fillOpacity: 0.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    stroke: "#979797",
    strokeOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.94599C9.05738 8.36884 10.2049 7 12.1415 7C13.9919 7 15.1538 8.17542 15.1538 9.84184C15.1538 11.9844 12.7153 12.1927 12.7153 13.993V14.5435C12.7153 14.6477 12.6722 14.6923 12.5718 14.6923H11.6538C11.5533 14.6923 11.5103 14.6477 11.5103 14.5435V14.0972C11.5103 11.7314 13.9489 11.4785 13.9489 9.85672C13.9489 8.81521 13.2317 8.1903 12.1415 8.1903C11.1373 8.1903 10.3197 8.78545 10.1763 9.94599C10.1619 10.0501 10.1332 10.0948 10.0328 10.0948H9.14345C9.04303 10.0948 9 10.0501 9 9.94599ZM11.4615 15.4615H12.6923C12.8 15.4615 12.8462 15.5077 12.8462 15.6154V16.8462C12.8462 16.9538 12.8 17 12.6923 17H11.4615C11.3538 17 11.3077 16.9538 11.3077 16.8462V15.6154C11.3077 15.5077 11.3538 15.4615 11.4615 15.4615Z",
    fill: "#6C65F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "#6C65F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpActive);
export default __webpack_public_path__ + "static/media/help-active.6c14e1e7b704ff3cedf2f43f60e632bd.svg";
export { ForwardRef as ReactComponent };